module.exports = __webpack_public_path__ + "static/media/sigil-thumb-2-lannister.7453cb24.png";